var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-50 shadow-md rounded-sm p-3"},[_c('p',{staticClass:"text-gray-900 font-semibold"},[_vm._v(_vm._s(_vm.message.Title))]),_vm._v(" "),_c('p',{staticClass:"text-gray-600 text-xs"},[_vm._v(_vm._s(_vm.message.Content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }